module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik01MDAuOCA0NjEuOTA5MzMzTDI2Ny4zMDY2NjcgNjk1LjI5NmwtNDUuMjI2NjY3LTQ1LjI2OTMzMyAyNzguNzQxMzMzLTI3OC42MTMzMzRMNzc5LjMwNjY2NyA2NTAuMDI2NjY3bC00NS4yNDggNDUuMjI2NjY2eiIgLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/arrow-up.svg
// module id = 7QMd
// module chunks = 0 1